export type ScheduleKind = "publish" | "unpublish";

/** The listing row fields that carry a pending trigger, one per kind. */
export const SCHEDULE_ROW_FIELD: Record<ScheduleKind, string> = {
  publish: "scheduled_publish_trigger_datetime",
  unpublish: "scheduled_unPublish_trigger_datetime",
};

export type ScheduleRowPatch = Partial<Record<string, string | null>>;

/** A listing row is the same item when it has the same page (fixed types) or document id. */
const isSameItem = (row: any, item: any) => {
  const page = item?.page ?? item?.Page;
  if (page && row?.page === page) return true;
  const documentId = item?.documentId ?? item?.document_id;
  return Boolean(documentId) && row?.document_id === documentId;
};

/**
 * Lays a value we KNOW is true over a freshly fetched listing. A reschedule or cancel has just
 * succeeded, but the listing is read from a store that may not have caught up yet; without this the
 * re-fetch can hand back the old time and overwrite what the editor just did. Rows that are not the
 * item are returned untouched.
 */
export const applyScheduleRowPatch = (rows: any[], item: any, patch?: ScheduleRowPatch): any[] => {
  if (!patch || !Array.isArray(rows)) return rows;
  return rows.map((row) => (isSameItem(row, item) ? { ...row, ...patch } : row));
};
